



















import { Vue, Component, Watch } from "vue-property-decorator";
import PartnerCard from '../components/PartnerCard.vue';
import { User } from '@/modules/core/models';
import {UserService} from "@/modules/partners/services/user.service";
import _ from "lodash";
import {Debounce} from "@/modules/core/utils/decorators"

@Component({
    components: { PartnerCard },
})
export default class PartnerDetail extends Vue {

  users = [] as Array<User>;
  page = 1;
  length: number = 3;

  async mounted () {
    //if (this.$store.state.isLogged === true) { TODO isLogged is not working
      let response = await UserService.list(this.page, 25);
      this.users = response[0];
      let total_items: number = response[1];
      this.users = this.users.filter(obj => !_.isEqual(obj,this.$store.state.loginUser));
      this.length = total_items / 25;
    //}
  }

    @Watch('page')
    @Debounce(300)
    async onPageChanged(val: Number, oldVal: Number) {
        let response = await UserService.list(val, 25);
        this.users = response[0];
        let total_items: number = response[1];
        this.users = this.users.filter(obj => !_.isEqual(obj,this.$store.state.loginUser));
        this.length = total_items / 25;
    }

}
